// src/components/copilot/blocks/ChartBlock.js
import { ResponsiveContainer, LineChart, Line, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

const PALETTE = ["#6366f1", "#10b981", "#f59e0b", "#ef4444"];

export default function ChartBlock({ block }) {
  const { chart_type, x, series = [], data = [], title, source } = block;
  const Chart = chart_type === "bar" ? BarChart : LineChart;
  const Series = chart_type === "bar" ? Bar : Line;

  // Values arrive as strings from SQL; coerce series values to numbers so the
  // Y axis scales correctly (otherwise recharts mis-scales / clips).
  const chartData = data.map((d) => {
    const o = { [x]: d[x] };
    series.forEach((s) => {
      const n = Number(d[s]);
      o[s] = Number.isFinite(n) ? n : d[s];
    });
    return o;
  });

  return (
    <div className="rounded-xl border border-border bg-card p-4">
      {(title || source) && (
        <div className="mb-2 flex items-center gap-2">
          {title && <span className="text-sm font-semibold text-foreground">{title}</span>}
          {source && (
            <span
              title={`Data source: ${source}`}
              className="inline-flex items-center rounded-full bg-muted px-2 py-0.5 text-[11px] font-medium text-muted-foreground whitespace-nowrap"
            >
              {source}
            </span>
          )}
        </div>
      )}
      <ResponsiveContainer width="100%" height={280}>
        <Chart data={chartData} margin={{ top: 16, right: 24, left: 4, bottom: 4 }}>
          <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
          <XAxis dataKey={x} tick={{ fontSize: 11 }} tickMargin={8} minTickGap={16} />
          <YAxis tick={{ fontSize: 11 }} width={48} domain={[0, "auto"]} />
          <Tooltip />
          {series.map((s, i) => (
            <Series
              key={s}
              type="monotone"
              dataKey={s}
              stroke={PALETTE[i % PALETTE.length]}
              fill={PALETTE[i % PALETTE.length]}
              strokeWidth={2}
              dot={{ r: 2 }}
              activeDot={{ r: 4 }}
            />
          ))}
        </Chart>
      </ResponsiveContainer>
    </div>
  );
}
